import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "routeItemsList" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import { RouteServiceStatus } from '../../types';
import { RouteItem } from '../../index';


export default /*@__PURE__*/_defineComponent({
  __name: 'RouteItemsList',
  props: {
    routeItems: {},
    hideArrows: { type: Boolean },
    isLoading: { type: Boolean }
  },
  emits: ['getRouteItemsIndex'],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routeItems, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "route"
            }, [
              _createVNode(_unref(RouteItem), {
                "destination-name": item.destinationName,
                ports: item.ports,
                status: item.status,
                "is-status-change-upcoming": item.isStatusChangeUpcoming,
                "click-handler": () => _ctx.$emit('getRouteItemsIndex', _ctx.routeItems, index),
                "is-arrow-hidden": _ctx.hideArrows
              }, null, 8, ["destination-name", "ports", "status", "is-status-change-upcoming", "click-handler", "is-arrow-hidden"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
            return _createElementVNode("li", {
              key: index,
              class: "route"
            }, [
              _createVNode(_unref(RouteItem), {
                "is-loading": true,
                "is-arrow-hidden": _ctx.hideArrows
              }, null, 8, ["is-arrow-hidden"])
            ])
          }), 64))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})